export function takeUrlParameter(name: string): string | null {
  const url = new URL(window.location.href);
  const value = url.searchParams.get(name);
  if (value != null) {
    url.searchParams.delete(name);
    window.history.replaceState(null, "", url.toString());
  }
  return value;
}
